const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirthdayHat3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450.52,
    height: "160mm",
    viewBox: "0 0 119.2 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M108.772 40.35c-2.808-7.176 1.535-15.475 10.238-19.576-.73 1.086-1.28 2.2-1.373 3.404 1.82-1.028 4.054-1.678 6.365-1.847-7.892 5.157-13.247 12.251-14.94 19.794-.286-.473-.096-1.282-.29-1.776",
    style: {
      fill: "#ee3264",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.132 41.077c1.097-6.966 9.864-12.901 19.66-13.312-1.693.844-3.637 2.26-4.727 3.515 1.944-.9 4.576-.978 6.618-.2-4.233 1.255-8.505 2.527-12.252 4.412-3.746 1.887-6.974 4.47-8.304 7.603-.004-1.257-1.189-.768-.995-2.018",
    style: {
      fill: "#94de4b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.936 31.491c-2.388-2.718-6.389-4.789-10.855-5.164 1.609.912 2.886 2.116 3.672 3.469-2.01-.184-4.113.189-5.768 1.028 2.078-1.051 9.056 3.116 10.358 4.08 2.956 2.19 5.013 5.06 5.447 8.103 1.22-3.69-.05-8.321-2.854-11.516",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.508 163.436 109.576 38.69l-60.268 124.15s1.69 17.34 62.057 17.923c51.456.496 57.143-17.328 57.143-17.328",
    style: {
      fill: "#db56ea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.13 157.956c0 4.754-5.735 8.609-12.816 8.609-7.076 0-12.813-3.855-12.813-8.609s5.737-8.608 12.813-8.608c7.08 0 12.817 3.854 12.817 8.608",
    style: {
      fill: "#94de4b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.621 136.587c0 1.698-2.046 3.071-4.568 3.071-2.526 0-4.572-1.373-4.572-3.07 0-1.694 2.046-3.07 4.572-3.07 2.522 0 4.568 1.376 4.568 3.07",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.4 101.36c0 1.695-2.047 3.068-4.57 3.068-2.521 0-4.568-1.373-4.568-3.068 0-1.696 2.047-3.071 4.569-3.071s4.568 1.375 4.568 3.07",
    style: {
      fill: "#94de4b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.98 167.585c0 1.696-2.046 3.069-4.572 3.069-2.522 0-4.568-1.373-4.568-3.069 0-1.695 2.046-3.068 4.568-3.068 2.526 0 4.572 1.373 4.572 3.068M71.579 158.606c0 1.83-2.205 3.31-4.929 3.31-2.72 0-4.924-1.48-4.924-3.31 0-1.826 2.205-3.308 4.924-3.308 2.724 0 4.929 1.482 4.929 3.308M114.04 70.437c0 1.83-2.206 3.31-4.926 3.31-2.723 0-4.928-1.48-4.928-3.31 0-1.826 2.205-3.307 4.928-3.307 2.72 0 4.925 1.481 4.925 3.307",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.433 100.246c0 1.696 2.046 3.071 4.572 3.071 1.055 0 2.021-.244 2.794-.647l-2.59-5.485c-.07-.003-.137-.007-.204-.007-2.526 0-4.572 1.373-4.572 3.068M118.34 57.244l-2.978-6.304c-2.057.401-3.56 1.67-3.56 3.18 0 1.826 2.205 3.308 4.929 3.308.564 0 1.104-.066 1.609-.184M156.122 137.222c-2.49.164-4.441 1.575-4.441 3.293 0 1.83 2.208 3.31 4.928 3.31.885 0 1.71-.158 2.43-.433l-2.917-6.17M66.21 132.756c2.522 0 4.568-1.376 4.568-3.072 0-1.541-1.693-2.814-3.902-3.033l-2.79 5.752a6.392 6.392 0 0 0 2.124.353M89.398 86.869c2.72 0 4.928-1.484 4.928-3.31 0-1.827-2.205-3.309-4.925-3.311l-2.903 5.98c.815.401 1.813.64 2.9.64M100.228 162.01c0 3.54-4.272 6.407-9.54 6.407-5.266 0-9.535-2.867-9.535-6.407 0-3.537 4.269-6.404 9.536-6.404 5.267 0 9.539 2.867 9.539 6.404",
    style: {
      fill: "#ffd400",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.44 115.304c0 3.537-4.268 6.407-9.535 6.407s-9.535-2.87-9.535-6.407 4.268-6.406 9.535-6.406 9.536 2.869 9.536 6.406",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1 142.543c0 4.754-5.74 8.609-12.816 8.609-7.077 0-12.813-3.855-12.813-8.609s5.736-8.608 12.813-8.608c7.077 0 12.816 3.854 12.816 8.608",
    style: {
      fill: "#94de4b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.526 117.506c0 5.333-6.439 9.66-14.38 9.66-7.94 0-14.379-4.327-14.379-9.66s6.438-9.66 14.38-9.66c7.94 0 14.379 4.327 14.379 9.66",
    style: {
      fill: "#ffd400",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.788 86.745c0 4.754-5.736 8.609-12.813 8.609-7.076 0-12.816-3.855-12.816-8.609s5.74-8.608 12.816-8.608c7.077 0 12.813 3.854 12.813 8.608",
    style: {
      fill: "#94de4b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.234 149.066c0 2.607-3.146 4.72-7.027 4.72-3.88 0-7.027-2.113-7.027-4.72 0-2.608 3.147-4.722 7.027-4.722 3.88 0 7.027 2.114 7.027 4.722",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.581 179.655c-14.08-1.418-23.244-4.003-29.203-6.729l4.738-11.173c.483.106.998.164 1.534.164 2.724 0 4.929-1.482 4.929-3.31 0-1.56-1.605-2.868-3.768-3.218l3.888-9.165c2.053 2.912 6.47 4.928 11.585 4.928 4.145 0 7.828-1.323 10.17-3.371l-.963 7.938a14.055 14.055 0 0 0-1.802-.113c-5.267 0-9.536 2.867-9.536 6.404 0 3.54 4.269 6.407 9.536 6.407.088 0 .173 0 .257-.002l-1.365 11.24m5.006-41.175c-2.163-2.706-6.414-4.545-11.303-4.545-2.568 0-4.957.506-6.96 1.38l6.233-14.705c1.524.696 3.366 1.101 5.348 1.101 4.6 0 8.439-2.186 9.338-5.099l-2.656 21.868m2.847-23.44c-.208-3.416-4.392-6.142-9.529-6.142-.13 0-.257.003-.384.005l14.94-35.248-.991 8.158c-1.454 1.398-2.311 3.098-2.311 4.932 0 1.336.452 2.598 1.26 3.726l-.953 7.848a6.59 6.59 0 0 0-.635-.03c-2.522 0-4.569 1.376-4.569 3.071 0 1.67 1.987 3.028 4.46 3.069l-1.288 10.611",
    style: {
      fill: "#edacf5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.722 104.428c-2.473-.04-4.46-1.398-4.46-3.068 0-1.696 2.047-3.071 4.569-3.071.215 0 .427.01.635.03l-.744 6.11",
    style: {
      fill: "#cbefa7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.65 161.917a7.179 7.179 0 0 1-1.534-.164l2.695-6.364c2.163.35 3.768 1.658 3.768 3.217 0 1.83-2.205 3.31-4.929 3.31",
    style: {
      fill: "#ffd9d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.689 168.417c-5.267 0-9.536-2.867-9.536-6.407 0-3.537 4.269-6.404 9.536-6.404.617 0 1.217.038 1.802.113l-1.545 12.695c-.084.003-.169.003-.257.003",
    style: {
      fill: "#ffea82",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.905 121.71c-1.982 0-3.824-.405-5.348-1.1l4.964-11.707c.127-.003.254-.005.384-.005 5.137 0 9.32 2.725 9.529 6.142l-.19 1.572c-.9 2.912-4.738 5.099-9.339 5.099",
    style: {
      fill: "#ffd9d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.284 151.152c-5.115 0-9.532-2.016-11.585-4.928l4.625-10.909c2.003-.874 4.392-1.38 6.96-1.38 4.89 0 9.14 1.839 11.303 4.544l-1.132 9.302c-2.343 2.048-6.026 3.37-10.171 3.37M100.418 90.471c-.807-1.129-1.259-2.39-1.259-3.726 0-1.834.857-3.535 2.31-4.933l-1.05 8.66",
    style: {
      fill: "#cbefa7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.508 163.436 137.986 98.83l-.258-.549 30.78 65.155m-31.298-66.25-7.532-15.938 7.532 15.937",
    style: {
      fill: "#cdcfd1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.457 180.774a283.358 283.358 0 0 1-9.99-.191c4.787-8.198 9.083-17.334 12.749-26.842.324.03.656.046.991.046 3.88 0 7.027-2.114 7.027-4.721 0-2.066-1.972-3.822-4.723-4.462a224.066 224.066 0 0 0 5.094-17.494c.508.037 1.02.055 1.541.055 7.941 0 14.38-4.326 14.38-9.659 0-4.825-5.264-8.823-12.146-9.543 1.393-9.672 1.88-18.787 1.298-26.715l7.532 15.937c-.071-.003-.138-.008-.205-.008-2.526 0-4.572 1.374-4.572 3.069 0 1.696 2.046 3.071 4.572 3.071 1.055 0 2.021-.244 2.794-.647l-1.813-3.84 30.522 64.606s-5.524 17.34-55.05 17.338m5.95-16.257c-2.522 0-4.568 1.373-4.568 3.068 0 1.696 2.046 3.069 4.568 3.069 2.526 0 4.572-1.373 4.572-3.069 0-1.695-2.046-3.068-4.572-3.068m22.906-15.17c-7.076 0-12.813 3.855-12.813 8.61 0 4.753 5.737 8.608 12.813 8.608 7.08 0 12.817-3.855 12.817-8.609s-5.736-8.608-12.817-8.608m13.808-12.126c-2.49.164-4.441 1.575-4.441 3.293 0 1.83 2.208 3.31 4.928 3.31.885 0 1.71-.158 2.43-.433l-2.917-6.17m-16.069-3.703c-2.526 0-4.572 1.375-4.572 3.068 0 1.698 2.046 3.071 4.572 3.071 2.522 0 4.568-1.373 4.568-3.07 0-1.694-2.046-3.07-4.568-3.07",
    style: {
      fill: "#b24dc1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.314 166.565c-7.076 0-12.813-3.855-12.813-8.609s5.737-8.608 12.813-8.608c7.08 0 12.817 3.854 12.817 8.608 0 4.754-5.736 8.609-12.817 8.609",
    style: {
      fill: "#7bb547",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.053 139.658c-2.526 0-4.572-1.373-4.572-3.07 0-1.694 2.046-3.07 4.572-3.07 2.522 0 4.568 1.376 4.568 3.07 0 1.697-2.046 3.07-4.568 3.07",
    style: {
      fill: "#cdcfd1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.408 170.654c-2.522 0-4.568-1.373-4.568-3.069 0-1.695 2.046-3.068 4.568-3.068 2.526 0 4.572 1.373 4.572 3.068 0 1.696-2.046 3.069-4.572 3.069",
    style: {
      fill: "#cc9396",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.005 103.317c-2.526 0-4.572-1.375-4.572-3.07 0-1.696 2.046-3.07 4.572-3.07.067 0 .134.006.205.008l.518 1.096.258.55 1.813 3.839c-.773.403-1.74.647-2.794.647M156.609 143.825c-2.72 0-4.928-1.48-4.928-3.31 0-1.718 1.95-3.129 4.441-3.293l2.917 6.17a6.834 6.834 0 0 1-2.43.433M126.146 127.165c-.522 0-1.033-.017-1.541-.055 1.608-6.5 2.878-12.937 3.775-19.147 6.882.72 12.146 4.719 12.146 9.543 0 5.333-6.439 9.66-14.38 9.66",
    style: {
      fill: "#cdae00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.207 153.787c-.335 0-.667-.015-.991-.045a222.162 222.162 0 0 0 3.295-9.138c2.751.64 4.723 2.396 4.723 4.462 0 2.607-3.146 4.72-7.027 4.72",
    style: {
      fill: "#cc9396",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298121
    },
    transform: "translate(-49.308 -20.774)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayHat3);
export default __webpack_public_path__ + "static/media/birthday_hat_3.0a0b8fd8a40a119b43e589d2c1b24f44.svg";
export { ForwardRef as ReactComponent };